import {
  DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_BEGIN,
  DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_SUCCESS,
  DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_FAILURE,
  DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function appwriteCollectionUpdate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/appwrites/update-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !');
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_FAILURE,
            data: { error: err },
          });
          toast.error(`Updation Failed !`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAppwriteCollectionUpdateError() {
  return {
    type: DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_BEGIN:
      return {
        ...state,
        appwriteCollectionUpdatePending: true,
        appwriteCollectionUpdateError: null,
      };

    case DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_SUCCESS:
      return {
        ...state,
        appwriteCollectionUpdatePending: false,
        appwriteCollectionUpdateError: null,
      };

    case DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_FAILURE:
      return {
        ...state,
        appwriteCollectionUpdatePending: false,
        appwriteCollectionUpdateError: action.data.error,
      };

    case DATA_CONNECTOR_APPWRITE_COLLECTION_UPDATE_DISMISS_ERROR:
      return {
        ...state,
        appwriteCollectionUpdateError: null,
      };

    default:
      return state;
  }
}
